module.exports = __webpack_public_path__ + "img/center_tLeftBack.5f41387f.png";